import { call, takeLatest } from 'redux-saga/effects';

import { VIRTUAL_VISIT_EVENTS } from '../../../constants';
import { finishVirtualVisit } from './finish-virtual-visit-saga';
import { declineVirtualVisit } from './decline-virtual-visit-saga';
import { APPOINTMENT_DETAILS_TYPES } from '../appointment-details';
import * as changeAppointmentStatus from '../requests/status-change-req';
import {
  startVirtualVisit,
  handleFailedChangeStatus,
} from './start-virtual-visit-saga';

function* handleStatusChange({ payload }) {
  const { event } = payload;

  switch (event) {
    case VIRTUAL_VISIT_EVENTS.START_VISIT: {
      yield call(startVirtualVisit, payload);
      break;
    }

    case VIRTUAL_VISIT_EVENTS.DECLINE_VISIT:
    case VIRTUAL_VISIT_EVENTS.BREAK_VISIT: {
      yield call(declineVirtualVisit, payload);
      break;
    }

    case VIRTUAL_VISIT_EVENTS.FINISH_VISIT: {
      yield call(finishVirtualVisit, payload);
      break;
    }
  }
}

export default function* changeAppointmentStatusSaga() {
  yield takeLatest(APPOINTMENT_DETAILS_TYPES.CHANGE_STATUS, handleStatusChange);
  yield takeLatest(
    [
      changeAppointmentStatus.consts.REJECTED,
      changeAppointmentStatus.consts.ERROR_ENCOUNTERED,
    ],
    handleFailedChangeStatus,
  );
}



// WEBPACK FOOTER //
// ./src/redux/healthboard/sagas/change-status-saga.js